import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DynamicDialogRef } from '../../../../core/services/dialog';
import { TranslatePipe } from '../../../pipes/translate/translate.pipe';
import { DialogContentLayout } from '../../dialog/dialog-content-layout/dialog-content-layout';

/**
 * KeyboardShortcutsDialogComponent component.
 * Provides UI presentation and event handling for keyboard shortcuts dialog component.
 */
@Component({
  selector: 'app-keyboard-shortcuts-dialog',
  standalone: true,
  imports: [CommonModule, DialogContentLayout, TranslatePipe],
  templateUrl: './keyboard-shortcuts-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./keyboard-shortcuts-dialog.component.scss'],
})
export class KeyboardShortcutsDialogComponent {
  /** Injected service for dialog ref. */
  private dialogRef = inject(DynamicDialogRef);

  /** Property shortcuts. */
  shortcuts = [
    {
      labelKey: 'breadcrumbHold',
      descKey: 'breadcrumbHoldDesc',
      keys: 'Space',
    },
    {
      labelKey: 'assistantFocus',
      descKey: 'assistantFocusDesc',
      keys: 'Shift + Space',
    },
    {
      labelKey: 'headerNavigation',
      descKey: 'headerNavigationDesc',
      keys: 'Shift + H',
    },
    { labelKey: 'mainContent', descKey: 'mainContentDesc', keys: 'Shift + C' },
    { labelKey: 'actionsBar', descKey: 'actionsBarDesc', keys: 'Shift + A' },
    {
      labelKey: 'footerLinkage',
      descKey: 'footerLinkageDesc',
      keys: 'Shift + F',
    },
    { labelKey: 'dataList', descKey: 'dataListDesc', keys: 'Shift + L' },
    { labelKey: 'listCreate', descKey: 'listCreateDesc', keys: 'Shift + N' },
    { labelKey: 'rowActions', descKey: 'rowActionsDesc', keys: 'Shift + E' },
    {
      labelKey: 'listQuickView',
      descKey: 'listQuickViewDesc',
      keys: 'Shift + Q',
    },
  ];

  /**
   * Handles close logic.
   */
  close() {
    this.dialogRef.close();
  }
}
